
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta } from "/vercel/path0/pages/settings.vue?macro=true";
import { default as indexxRLk0XlwnpkNVLe2bTaJPTTL42oM9cmLiSDxdwtd_4570Meta } from "/vercel/path0/pages/medications/index.vue?macro=true";
import { default as _91slug_939tib0ioa6g3Yf_45VC5Bp_45oEYeczX59TNTAyfDuRTlQ3oMeta } from "/vercel/path0/pages/medications/[slug].vue?macro=true";
import { default as general_informationVq1iCEPOpnjN6Y6u_D5SFXFBysCS3ZA_45X6pZZ71MGK0Meta } from "/vercel/path0/pages/general_information.vue?macro=true";
import { default as indexijseZHXm0EUl0D_ahJ5wKniklIUGO45TJtQcXpe4uX4Meta } from "/vercel/path0/pages/active_ingredients/index.vue?macro=true";
import { default as _91slug_93VqMRod4DydwyfaydYiL622usrfBPubpq8Dtwt0_LV40Meta } from "/vercel/path0/pages/active_ingredients/[slug].vue?macro=true";
export default [
  {
    name: "index___de",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "Settings___de",
    path: "/settings",
    meta: settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta || {},
    component: () => import("/vercel/path0/pages/settings.vue")
  },
  {
    name: "Settings___fr",
    path: "/fr/settings",
    meta: settings9Itu3riP9CqWX2opHgufCqw701YOBx4__ysuXBnjXKQMeta || {},
    component: () => import("/vercel/path0/pages/settings.vue")
  },
  {
    name: "Medications___de",
    path: "/medications",
    meta: indexxRLk0XlwnpkNVLe2bTaJPTTL42oM9cmLiSDxdwtd_4570Meta || {},
    component: () => import("/vercel/path0/pages/medications/index.vue")
  },
  {
    name: "Medications___fr",
    path: "/fr/medications",
    meta: indexxRLk0XlwnpkNVLe2bTaJPTTL42oM9cmLiSDxdwtd_4570Meta || {},
    component: () => import("/vercel/path0/pages/medications/index.vue")
  },
  {
    name: "Medicine___de",
    path: "/medications/:slug()",
    meta: _91slug_939tib0ioa6g3Yf_45VC5Bp_45oEYeczX59TNTAyfDuRTlQ3oMeta || {},
    component: () => import("/vercel/path0/pages/medications/[slug].vue")
  },
  {
    name: "Medicine___fr",
    path: "/fr/medications/:slug()",
    meta: _91slug_939tib0ioa6g3Yf_45VC5Bp_45oEYeczX59TNTAyfDuRTlQ3oMeta || {},
    component: () => import("/vercel/path0/pages/medications/[slug].vue")
  },
  {
    name: "GeneralInformation___de",
    path: "/general_information",
    meta: general_informationVq1iCEPOpnjN6Y6u_D5SFXFBysCS3ZA_45X6pZZ71MGK0Meta || {},
    component: () => import("/vercel/path0/pages/general_information.vue")
  },
  {
    name: "GeneralInformation___fr",
    path: "/fr/general_information",
    meta: general_informationVq1iCEPOpnjN6Y6u_D5SFXFBysCS3ZA_45X6pZZ71MGK0Meta || {},
    component: () => import("/vercel/path0/pages/general_information.vue")
  },
  {
    name: "ActiveIngredients___de",
    path: "/active_ingredients",
    meta: indexijseZHXm0EUl0D_ahJ5wKniklIUGO45TJtQcXpe4uX4Meta || {},
    component: () => import("/vercel/path0/pages/active_ingredients/index.vue")
  },
  {
    name: "ActiveIngredients___fr",
    path: "/fr/active_ingredients",
    meta: indexijseZHXm0EUl0D_ahJ5wKniklIUGO45TJtQcXpe4uX4Meta || {},
    component: () => import("/vercel/path0/pages/active_ingredients/index.vue")
  },
  {
    name: "ActiveIngredient___de",
    path: "/active_ingredients/:slug()",
    meta: _91slug_93VqMRod4DydwyfaydYiL622usrfBPubpq8Dtwt0_LV40Meta || {},
    component: () => import("/vercel/path0/pages/active_ingredients/[slug].vue")
  },
  {
    name: "ActiveIngredient___fr",
    path: "/fr/active_ingredients/:slug()",
    meta: _91slug_93VqMRod4DydwyfaydYiL622usrfBPubpq8Dtwt0_LV40Meta || {},
    component: () => import("/vercel/path0/pages/active_ingredients/[slug].vue")
  }
]